import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import * as S from './FormLoss.styles'
import { useDispatch } from 'react-redux'
import { actions } from '../../LossState'
import { useSelector } from 'src/utils/store'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { SelectChangeEvent } from '@mui/material'
import { handleOnKeyDown } from 'src/utils/Form'

export const FormLoss = () => {
  const {
    reset, register, trigger, setFocus, getValues, setError, clearErrors, watch, formState: { errors },
  } = useForm()

  const dispatch = useDispatch()
  const { badge, productDescription, addressList: productList } = useSelector((state) => state.loss)
  const { fc } = useFulfillmentCenter()

  useEffect(() => {
    if (badge) return
    reset({ badge: '', barcode: '', localization: '' })
  }, [reset, badge])

  const getProductList = () => {
    const onSuccess = () => {
      clearErrors('localization')
      reset({ localization: '' })
      dispatch(actions.updateLossState({ key: 'selectLocation', value: '' }))
    }

    dispatch(
      actions.getProductLocation({
        barcode: getValues('barcode'),
        fcId: fc.id,
        setError: (message) => setError('localization', { message }),
        onSuccess,
      }),
    )
  }

  const onBadgeSubmit = async () => {
    const validationSuccess = await trigger('badge')

    const onSuccess = async () => {
      setFocus('barcode')
    }

    if (validationSuccess) {
      dispatch(
        actions.validateSupervisorBadge({
          badge: getValues('badge'),
          onSuccess,
          setError: (message) => setError('badge', { message }),
        }),
      )
    }
  }

  const getSelectedLocalization = (event: SelectChangeEvent<unknown>) => {
    dispatch(actions.updateLossState({ key: 'selectLocation', value: event.target.value as number }))
  }

  const onBarcodeSubmit = async () => {
    const validationSuccess = await trigger('barcode')

    const onSuccess = () => {
      setFocus('localization')
    }

    if (validationSuccess) {
      dispatch(
        actions.getProductDescription({
          barcode: getValues('barcode'),
          getProductList,
          onSuccess,
        }),
      )
    }
  }

  return (
    <>
      <S.Wrapper>
        <S.TextForm
          id='badge'
          name='badge'
          type='password'
          autoComplete='off'
          inputProps={{ ...register('badge', { required: 'Campo obrigatório' }), 'data-testid': 'badge-test' }}
          error={!!errors.badge}
          label='loss.form.userBarcode'
          helperText={errors.badge?.message}
          fullWidth
          size='medium'
          disabled={!!badge}
          onKeyDown={(e) => handleOnKeyDown(e, 'barcode', onBadgeSubmit)}
        />
        <S.TextForm
          id='barcode'
          name='barcode'
          autoComplete='off'
          inputProps={{ ...register('barcode', { required: 'Campo obrigatório' }), 'data-testid': 'barcode-test' }}
          error={!!errors.barcode}
          label='loss.form.barcode'
          helperText={errors.barcode?.message}
          fullWidth
          size='medium'
          disabled={!badge}
          onKeyDown={(e) => handleOnKeyDown(e, 'localization', onBarcodeSubmit)}
        />
        <S.TextForm
          id='description'
          name='description'
          autoComplete='off'
          inputProps={{ ...register('description', { required: 'Campo obrigatório' }), 'data-testid': 'description-test' }}
          error={!!errors.description}
          label='loss.form.productDescription'
          InputLabelProps={{ shrink: !!productDescription }}
          helperText={errors.description?.message}
          fullWidth
          size='medium'
          value={productDescription || ''}
          disabled
        />
        <S.SelectForm
          defaultValue=''
          autoComplete='off'
          value={watch('localization') || ''}
          inputProps={{ ...register('localization', { required: 'Campo obrigatório' }), 'data-testid': 'localization-test' }}
          id='localization-select'
          error={!!errors.localization}
          label='Localização'
          helperText={errors.localization?.message}
          variant='outlined'
          options={productList || []}
          onChange={getSelectedLocalization}
          disabled={!productDescription}
          size='medium'
          type='text'
          fullWidth
        />
      </ S.Wrapper>
    </>
  )
}
